"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var get = function get(propertyObject, path) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'undefined';
  var result;
  var propertyPath = Array.isArray(path) ? path : path.replace(/\[/g, '.').replace(/\]/g, '').split('.');
  try {
    propertyPath.forEach(function (value, index) {
      var isObj = (0, _typeof2["default"])(result) === 'object';
      if (index === 0) {
        result = propertyObject[value];
      } else {
        result = isObj ? result[value] : defaultValue;
      }
    });
  } catch (e) {
    result = defaultValue;
  }
  return result;
};
var _default = exports["default"] = get;